import React from 'react'
import CreateConceptualLabelDrawer from './CreateConceptualLabelDrawer'
import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import conceptualLabelSelectors from '../../../../../store/selectors/conceptual-label.selectors'
import { conceptualLabelActions } from '../../../../../store/slices/conceptual-label.slice'

const CreateConceptualLabelButton = ({ type }) => {
    const showDrawer = useSelector(conceptualLabelSelectors.showCreateConceptualLabelDrawer)
    const dispatch = useDispatch()

    const handleCreateClick = () => dispatch(conceptualLabelActions.setShowCreateConceptualLabelDrawer(true))

    return (
        <>
            <Button icon={<PlusOutlined aria-hidden='true' />} type={type} onClick={handleCreateClick}>
                Create new
            </Button>
            {showDrawer && <CreateConceptualLabelDrawer />}
        </>
    )
}

export default CreateConceptualLabelButton
